module.exports = __webpack_public_path__ + "media/SOC/envelope-92045d4e.svg";